import { Injectable } from '@angular/core';

import { BackendApiService, UserService } from '@shared/core';
import { USER } from '../actions/index';
import {
	UserHydrateAction,
	UserHydrateFailureAction,
	UserHydrateSuccessAction,
	UserSyncFailureAction,
	UserSyncSuccessAction
} from '../actions/user-actions';
import { Action } from '../action';
import { getSessionUid } from '../selectors';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap, takeUntil } from 'rxjs/operators';

@Injectable()
export class UserEffects {
	@Effect()
	hydrate: Observable<Action> = this.actions$.pipe(
		ofType<UserHydrateAction>(USER.HYDRATE),
		switchMap(action =>
			this.user.hydrate().pipe(
				takeUntil(
					this.store.pipe(
						select(getSessionUid),
						filter(x => !x)
					)
				),
				map(u => new UserHydrateSuccessAction(u, action.correlationId)),
				catchError(e => of(new UserHydrateFailureAction(e, action.correlationId)))
			)
		)
	);
	@Effect()
	refreshCurrentUser$ = this.actions$.pipe(
		ofType(USER.SYNC),
		switchMap(() => {
			return this.backendApi.syncAccount().pipe(
				map(_x => new UserSyncSuccessAction()),
				catchError(e => of(new UserSyncFailureAction(e)))
			);
		})
	);

	constructor(
		private actions$: Actions,
		private store: Store<any>,
		private user: UserService,
		private backendApi: BackendApiService
	) {}
}
